import { render, staticRenderFns } from "./instagramFeed.vue?vue&type=template&id=1e11eb11&scoped=true&"
import script from "./instagramFeed.vue?vue&type=script&lang=js&"
export * from "./instagramFeed.vue?vue&type=script&lang=js&"
import style0 from "./instagramFeed.vue?vue&type=style&index=0&id=1e11eb11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e11eb11",
  null
  
)

export default component.exports